module.exports = __webpack_public_path__ + "d6c6ed22db17d506d8fa997d5ae7988b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/ball-basketball.png
// module id = 2355
// module chunks = 0